<template>
    <button
        @click="toggleSidebar"
        class="text-gray-500 focus:outline-none lg:hidden"
        :class="{ 'sidebar-visible': !sidebarVisible }"
    >


    <svg v-if="sidebarVisible" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-6 h-6">
        <path stroke-linecap="round" stroke-linejoin="round" d="M6 18 18 6M6 6l12 12" />
    </svg>
 
        <svg v-if="!sidebarVisible" 
            class="w-6 h-6"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M4 6H20M4 12H20M4 18H11"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
            />
        </svg>
    </button>
    <div class="flex sidebar" 
        :class="{ 'sidebar-visible': !sidebarVisible }"
        ref="sidebar"
  
  >


    <div
     
      class="
        fixed
        inset-y-0
        left-0
        z-30
       
        overflow-y-auto
        transition
        duration-300
        transform
        bg-gray-900
        lg:translate-x-0 lg:static lg:inset-0
      "
        >
            <div class="flex items-center justify-center mt-8">
                <div class="flex items-center">
                    <img class="logo" src="@/assets/img/ceLogo.png" />
                </div>
            </div>
            <p  class="mt-5 mb-5  text-center">PLATEFORME</p>
            <nav >
                <ul class="menu bg-base-200 rounded-box">

                    <li>
                        <router-link
                            to="/admin/dashboard"
                        >Dashboard
                        </router-link>
                    </li>
                    <li>
                        <details >
                            <summary>{{ $t("mainMenu.catalog.nameSection") }}</summary>
                            <ul class="collapse list-unstyled" id="homeCatalogue">
                                <li>
                                    <details>
                                        <summary>Catégories</summary>
                                        <ul class="collapse list-unstyled">
                                            <li>
                                                <router-link :to="{ name: 'listCategories' }">
                                                    {{ $t("mainMenu.catalog.category") }}
                                                </router-link>
                                            </li>
                                            <li>
                                                <router-link :to="{ name: 'filterableCategoryList' }">
                                                    <span>Filtres</span>
                                                </router-link>
                                            </li>
                                            <li>
                                                <router-link :to="{ name: 'categoryTreeview' }">
                                                    <span>Arborescence</span>
                                                </router-link>
                                            </li>
                                            <li>
                                                <router-link :to="{ name:'listMegaMenusCategories'}">
                                                    <span>Mises en avant</span>
                                                </router-link>
                                            </li>
                                        </ul>
                                    </details>
                                </li>
                                <li>
                                    <details>
                                        <summary>Produits</summary>
                                        <ul class="collapse list-unstyled">
                                            <li>
                                                <router-link to='/admin/catalogue/ListProducts'>
                                                    {{ $t("mainMenu.catalog.products") }}
                                                </router-link>
                                            </li>
                                            <li>
                                                <router-link to='/admin/properties/list'>
                                                    {{ $t("mainMenu.catalog.properties") }}
                                                </router-link>
                                            </li>
                                            <li>
                                                <router-link :to="{ name: 'listVariantProductCollection' }">
                                                    {{ $t("mainMenu.catalog.variantProductCollection") }}
                                                </router-link>
                                            </li>
                                           <li>
                                                <router-link :to="{ name: 'companiesList' }">
                                                    {{ $t("mainMenu.catalog.companiesList") }}
                                                </router-link>
                                            </li>
                                            <li>
                                                <router-link :to="{ name: 'ListUrssaf' }">
                                                    {{ $t("mainMenu.catalog.urssaf") }}
                                                </router-link>
                                            </li>
                                        </ul>
                                    </details>
                                </li>
                                
                                <li>
                                    <details>
                                        <summary>API Carte cadeau</summary>
                                        <ul class="collapse list-unstyled">
                                            <li>
                                                <router-link to='/admin/catalogue/gift-card-product-api'>
                                                    {{ $t("mainMenu.catalog.jackpot") }}
                                                </router-link>
                                            </li>
                                            <li class="w-11/12">
                                                <router-link to='/admin/catalogue/list-ogloba-order'>
                                                    {{ $t("mainMenu.catalog.orderManualOgloba") }}
                                                </router-link>
                                            </li>
                                        </ul>
                                    </details>
                                </li>
                                <li>
                                    <details>
                                        <summary>Stock</summary>
                                        <ul class="collapse list-unstyled">
                                            <li>
                                                <router-link to='/admin/catalogue/ListDocuments'>
                                                    {{ $t("mainMenu.catalog.documents") }}
                                                </router-link>
                                            </li>
                                            <li>
                                                <router-link to='/admin/catalogue/ListCodes'>
                                                    {{ $t("mainMenu.catalog.codes") }}
                                                </router-link>
                                            </li>
                                        </ul>
                                    </details>
                                </li>
                                <li>
                                    <router-link :to="{ name: 'soldExport' }">
                                        <span>Exports</span>
                                    </router-link>
                                </li>
                                <li>
                                    <router-link to='/admin/catalogue/monitoring-ogloba-order'>
                                        {{ $t("mainMenu.catalog.monitoringOglobaOrder") }}
                                    </router-link>
                                </li>
                            </ul>
                        </details>
                    </li>
                    <li>
                        <details >
                            <summary>Fournisseurs</summary>
                            <ul class="collapse list-unstyled" id="pageSupplier">
                                <li>
                                    <router-link :to="{ name: 'suppliersList' }">
                                        <span>Fournisseurs</span>
                                    </router-link>
                                </li>
                                <li>
                                    <router-link :to="{ name: 'transporterList' }">
                                        <span>Transporteurs</span>
                                    </router-link>
                                </li>
                            </ul>
                        </details>
                    </li>
                    <li>
                        <details >
                            <summary>Login</summary>
                            <ul class="collapse list-unstyled" id="Login">
                                <li>
                                    <router-link :to="{ name: 'carouselLoginList' }">
                                        <span>Carrousels</span>
                                    </router-link>
                                </li>
                            </ul>
                        </details>
                    </li>
                    <li>
                        <details >
                            <summary>Homepage</summary>
                            <ul class="collapse list-unstyled" id="Homepage">
                                <li>
                                    <router-link :to="{ name: 'carouselList' }">
                                        <span>Carrousels</span>
                                    </router-link>
                                </li>
                                <li>
                                    <router-link :to="{ name: 'middleMenuList' }">
                                        <span>Nos offres du moment</span>
                                    </router-link>
                                </li>
                                <li>
                                    <router-link :to="{ name: 'newsList' }">
                                        <span>Nouveautés</span>
                                    </router-link>
                                </li>
                                <li>
                                    <router-link :to="{ name: 'travelList' }">
                                        <span>Voyage</span>
                                    </router-link>
                                </li>
                                <li>
                                    <router-link :to="{ name: 'regionList' }">
                                        <span>Région</span>
                                    </router-link>
                                </li>
                            </ul>
                        </details>
                    </li>
                    <li>
                        <details >
                            <summary>Sécurité</summary>
                            <ul class="collapse list-unstyled">
                                <li>
                                    <router-link :to="{ name: 'whitelist' }">
                                        <span>Whitelist 2FA</span>
                                    </router-link>
                                </li>
                                <li>
                                    <router-link :to="{ name: 'enable2FaStrongAuthentication' }">
                                        <span>Authentification forte</span>
                                    </router-link>
                                </li>
                                <li>
                                    <router-link :to="{ name: 'usersBlackList' }">
                                        <span>Personnes blacklistées</span>
                                    </router-link>
                                </li>
                                <li>
                                    <router-link :to="{ name: 'enabledUsersList' }">
                                        <span>Utilisateurs Actifs</span>
                                    </router-link>
                                </li>
                                <li>
                                    <router-link :to="{ name: 'mobileApprovedVersionList' }">
                                        <span>Versions mobiles approuvées</span>
                                    </router-link>
                                </li>
                            </ul>
                        </details>
                    </li>
                    <li>
                        <details >
                            <summary>{{ $t("mainMenu.registrationNumber.nameSection") }}</summary>
                            <ul class="collapse list-unstyled">
                                <li>
                                    <router-link :to="{ name: 'importCompanyMatricule' }">
                                        <span>{{ $t("mainMenu.registrationNumber.importRegistrationNumbers") }}</span>
                                    </router-link>
                                </li>
                                <li>
                                    <router-link :to="{ name: 'companyMatriculeWithUserList' }">
                                        <span>{{ $t("mainMenu.registrationNumber.companyMatricules") }}</span>
                                    </router-link>
                                </li>
                            </ul>
                        </details>
                    </li>
                </ul>
            </nav>
            
        </div>
    </div>
</template>

<script setup lang="ts">
    import { ref } from 'vue';

    const sidebarVisible = ref(false);

    const toggleSidebar = () => {
        sidebarVisible.value = !sidebarVisible.value;
    };

    

</script>
<style scoped lang="scss">
.logo{
    padding: 0 40px;
}
.router-link-active {
    background : darkblue;
    color: var(--primary-color-text);
}
.sidebar {
    width : 300px;
    .menu :where(li ul) {
        padding-right: 0.5rem;
        margin-right: 1rem;
        width : auto;
    }
}
@media (max-width: 768px) {
    button {
        position: absolute;
        top: 0;
        left: 256px;
            &.sidebar-visible {
            left: 0;
        }
    }
    .sidebar {
        &.sidebar-visible {
            display: none;
        }
    }
}


</style>
